import React, { Component } from "react";
import "./RateBuilderV2.scss";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import InputV2 from "../Inputs/Input/InputV2";
import MediaMath from "../../Helpers/MediaMathHelpers";
import Fieldset from "@acadia-ui/fieldset";
import Radio, { RadioGroup } from "@acadia-ui/radio";
import ChangeEvents from "./ChangeEvents";
import ErrorHelpers from "./ErrorHelpers";

import PlacementDataStore from "../../Flux/Stores/PlacementDataStore";

class RateBuilderV2 extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	componentDidMount() {}

	componentWillUnmount() {}

	buildRateFields = () => {
		let isLocked =
			this.props.formEl == "edit_package" &&
			PlacementDataStore?.getData?.()?.some((datum) => datum?.IsPrismaBudgetLocked == "True") &&
			(this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "3" ||
				this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "6" ||
				this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "2");

		if (this.props.formEl === "edit_placement" && this?.props?.state?.packageData?.packageType === "Standard") {
			isLocked = true;
		}

		const enforceMaxInputPrecision = (event, maxPrecision) => {
			const { value } = event.target;
			if (!value.includes(".")) return event;
			const [left, right] = value.split(".");

			if (right.length > maxPrecision) {
				event.target.value = `${left}.${right.slice(0, maxPrecision)}`;
			}
			return event;
		};

		const rateFields = [];
		const currencySymbol = BookFiltersStore.getCurrencySymbol();
		const config = this.props.rateFieldsInConfig;
		let tempRate;
		let rateIndex;
		config.forEach((field, index) => {
			if (field[0].Name === "Rate") {
				tempRate = field;
				rateIndex = index;
			}
		});
		config.splice(rateIndex, 1);
		config.push(tempRate);
		config.forEach((rateField) => {
			const field = rateField[0];
			if (field.Name === "Rate") {
				let stringRate = this.props.state.formData[field.Name] ? this.props.state.formData[field.Name].value.toString() : "";

				if (stringRate && stringRate.indexOf(".") !== -1 && stringRate.slice(stringRate.indexOf(".") + 1).length > 4) {
					stringRate = parseFloat(parseFloat(stringRate).toFixed(4)) || stringRate;
				}

				rateFields.push(
					<div className="form__group width--pct--30 rateField" key={field.Name}>
						{/* <label htmlFor={field.Name} className={`${this.props.type} ${field.Name} like--label`}>
							{field.Label}
							{field.FieldDescription !== null && (
								<SvgInfo description={field.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
							)}
						</label> */}
						<InputV2
							readOnly={isLocked || this.props.state.valueToCalculate === null || this.props.state.valueToCalculate === "unitRate"}
							// type={"text"}
							type={"currency"}
							name={field.Name}
							className="like--input textboxWrapper"
							id={field.ID}
							dataConfig={rateField[1]}
							labelText={field.Label}
							required={true}
							icon={currencySymbol !== null ? currencySymbol : ""}
							// value={
							// 	this.props.state.formData[field.Name]
							// 		? (currencySymbol !== null ? currencySymbol : "") + stringRate
							// 		: (currencySymbol !== null ? currencySymbol : "") + 0
							// }
							value={this.props.state.formData[field.Name] ? stringRate : 0}
							handleInputChange={(event) => {
								ChangeEvents.handleRateChange(enforceMaxInputPrecision(event, 4), this.props.updateState, this.props.state);
							}}
						/>
						<div className={`errors__${field.Name}`} />
					</div>
				);
			} else if (field.Name === "PlannedUnits") {
				rateFields.push(
					<div className="form__group width--pct--30 rateField" key={field.Name}>
						{/* <label htmlFor={field.Name} className={`${this.props.type} ${field.Name} required like--label`}>
							{field.Label}
							{field.FieldDescription !== null && (
								<SvgInfo description={field.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
							)}
						</label> */}
						<InputV2
							readOnly={isLocked || this.props.state.valueToCalculate === null || this.props.state.valueToCalculate === "plannedUnits"}
							type={"text"}
							name={field.Name}
							className="like--input textboxWrapper"
							id={field.ID}
							required={true}
							dataConfig={rateField[1]}
							labelText={field.Label}
							value={this.props.state.formData[field.Name] ? this.props.state.formData[field.Name].value : ""}
							handleInputChange={(event) => {
								event.target.value = event.target.value == "" ? 0 : parseInt(event.target.value);
								ChangeEvents.handleInputChange(event, this.props.updateState, "number");
							}}
						/>
						<div className={`errors__${field.Name}`} />
					</div>
				);
			} else if (field.Name === "Cost") {
				let stringCost = this.props.state.formData[field.Name] ? this.props.state.formData[field.Name].value.toString() : "";

				if (stringCost && stringCost.indexOf(".") !== -1 && stringCost.slice(stringCost.indexOf(".") + 1).length > 2) {
					stringCost = parseFloat(parseFloat(stringCost).toFixed(2)) || stringCost;
				}

				rateFields.push(
					<div className="form__group width--pct--30 rateField" key={field.Name}>
						{/* <label htmlFor={field.Name} className={`${this.props.type} ${field.Name} like--label`}>
							{field.Label}
							{field.FieldDescription !== null && (
								<SvgInfo description={field.FieldDescription} style={{ enableBackground: "new 0 0 60 60", width: "20px", height: "20px" }} viewBox="-15 -7 30 15" />
							)}
						</label> */}
						<InputV2
							readOnly={isLocked || this.props.state.valueToCalculate === null || this.props.state.valueToCalculate === "plannedTotalCost"}
							// type={"text"}
							type={"currency"}
							name={field.Name}
							className="like--input textboxWrapper"
							id={field.ID}
							dataConfig={rateField[1]}
							labelText={field.Label}
							required={true}
							icon={currencySymbol !== null ? currencySymbol : ""}
							// value={
							// 	this.props.state.formData[field.Name]
							// 		? (currencySymbol !== null ? currencySymbol : "") + stringCost
							// 		: (currencySymbol !== null ? currencySymbol : "") + 0
							// }
							value={this.props.state.formData[field.Name] ? stringCost : 0}
							handleInputChange={(event) => {
								ChangeEvents.handleRateChange(enforceMaxInputPrecision(event, 2), this.props.updateState, this.props.state);
							}}
						/>
						<div className={`errors__${field.Name}`} />
					</div>
				);
			}
		});
		return rateFields;
	};

	handleCalculateChange = (value) => {
		this.props.updateCalculatedField(value);
		MediaMath.resetAllRateFields(this.props.updateState, this.props.formEl, this.props.parentRef);
		ErrorHelpers.resetCalculateErrors(this.props.formEl);
	};

	render() {
		let disableCalculate = false;
		if ((this.props.formEl === "create_placement" || this.props.formEl === "edit_placement") && this?.props?.state?.packageData?.packageType === "Standard") {
			disableCalculate = true;
		}

		if (
			this.props.formEl == "edit_package" &&
			PlacementDataStore?.getData?.()?.some((datum) => datum?.IsPrismaBudgetLocked == "True") &&
			(this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "3" ||
				this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "6" ||
				this.props?.parentRef?.props?.packageData?.ExternalSystemStatusID == "2")
		) {
			disableCalculate = true;
		}

		return (
			<div className="rateBuilderContainer">
				<RadioGroup
					className="field-set"
					disabled={disableCalculate}
					legend="Select a value you want to calculate, and the system will refresh the content below."
					layout="horizontal"
				>
					<div className="radio-container">
						<Radio
							disabled={disableCalculate}
							name="plannedUnits"
							value="plannedUnits"
							onChange={(evt) => this.handleCalculateChange(evt.target.value)}
							checked={this.props.state.valueToCalculate === "plannedUnits"}
						>
							Units
						</Radio>
						<Radio
							disabled={disableCalculate}
							name="plannedTotalCost"
							value="plannedTotalCost"
							onChange={(evt) => this.handleCalculateChange(evt.target.value)}
							checked={this.props.state.valueToCalculate === "plannedTotalCost"}
						>
							Cost
						</Radio>
						<Radio
							disabled={disableCalculate}
							name="unitRate"
							value="unitRate"
							onChange={(evt) => this.handleCalculateChange(evt.target.value)}
							checked={this.props.state.valueToCalculate === "unitRate"}
						>
							Rate
						</Radio>
					</div>
				</RadioGroup>
				{/* style={{ display: "flex", justifyContent: "space-around" }} */}
				<div className="textboxesContainer">{this.buildRateFields()}</div>
			</div>
		);
	}
}

export default RateBuilderV2;
